var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"app-loading ant-modal-mask"},[_c('a-spin',{attrs:{"size":"large","spinning":_vm.loading,"tip":_vm.tip}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }